
import { useState } from "react";

/**
 * Hook for managing resume-related state
 */
export const useResumeState = () => {
  const [showPreview, setShowPreview] = useState(false);
  const [selectedResume, setSelectedResume] = useState<any>(null);
  const [showPayment, setShowPayment] = useState(false);
  const [showFormatDialog, setShowFormatDialog] = useState(false);
  const [selectedFormat, setSelectedFormat] = useState<"pdf" | "docx">("pdf");
  const [isProcessing, setIsProcessing] = useState(false);

  return {
    showPreview,
    setShowPreview,
    selectedResume,
    setSelectedResume,
    showPayment,
    setShowPayment,
    showFormatDialog,
    setShowFormatDialog,
    selectedFormat,
    setSelectedFormat,
    isProcessing,
    setIsProcessing
  };
};
